<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.xs" width="1000">
    <v-card v-if="lead">
      <v-toolbar dense class="amber darken-1 white--text py-auto">
        <v-toolbar-title>Duyệt Đơn</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.stop="dialog = !dialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-tabs color="amber darken-1" class="" :vertical ="!$vuetify.breakpoint.xs" v-model="tab">
        <v-tab key="tab-1" >Đơn Hàng</v-tab>
        <v-tab key="tab-2" >Lịch Sử</v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item class="py-2 elevation-0" key="tab-1">
            <lead-edit :lead="lead"></lead-edit>
          </v-tab-item>
          <v-tab-item class="py-2 elevation-0" key="tab-2">
            <purchasing-history :lead="lead"></purchasing-history>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>
<script>
import LeadEdit from '@/modules/lead/LeadEdit.vue'
import PurchasingHistory from '@/modules/lead/bill/PurchasingHistory.vue'
export default {
  components: { LeadEdit, PurchasingHistory },
  props: {
    lead: Object,
    state: Boolean,
  },
  created() {},
  data() {
    return {
      dialog: false,
      tab: null,
      isMobile: false,
    }
  },
  computed: {},
  methods: {
    cancel() {
      this.dialog = false
    },
  },
  filters: {},
  watch: {
    state(state) {
      this.dialog = true
    },
  },
}
</script>
